import type { ReactNode } from "react";
import { HelpPopover } from "./HelpPopover";

// SettingCard: tarjeta de ajuste con titulo + summary glanceable opcional +
// cuerpo separado por borde. Extraida del monolito GlobalSettings (era inline).
// `help` agrega un "?" al lado del titulo para esconder la ayuda verbosa que
// antes vivia como parrafo siempre visible dentro del cuerpo.
export function SettingCard({
  title,
  summary,
  help,
  children,
}: {
  title: ReactNode;
  summary?: ReactNode;
  help?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="rounded-lg bg-white/5">
      <div className="px-4 pb-2.5 pt-3.5">
        <h3 className="flex items-center gap-1.5 font-bold">
          {title}
          {help && <HelpPopover>{help}</HelpPopover>}
        </h3>
        {summary && <div className="mt-1 text-xs opacity-60">{summary}</div>}
      </div>
      <div className="border-t border-white/10 p-4">{children}</div>
    </div>
  );
}

// Section: variante simple sin summary ni borde interno (un solo bloque).
// Extraida de Configuracion (el viejo `Section` local). Mantiene el markup
// para no cambiar el aspecto de Mi pantalla.
export function Section({
  title,
  help,
  children,
}: {
  title?: ReactNode;
  help?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="rounded-lg bg-white/5 p-4">
      {title && (
        <h2 className="mb-2 flex items-center gap-1.5 text-base font-bold">
          {title}
          {help && <HelpPopover>{help}</HelpPopover>}
        </h2>
      )}
      {children}
    </div>
  );
}
